export default __webpack_public_path__ + "static/media/icon-eye.719a3bc0.svg";